// import { useState, useEffect } from "react";
// import { useAuth } from "../Context/AuthContext";
// import API from "../Context/api";
// import ErrorMessage from "../Helpers/ErrorMessage";

// function EditInvoiceForm({ id, setIsModalOpen, onInvoiceUpdated }) {
//   const [invoiceData, setInvoiceData] = useState(null);
//   const [customer, setCustomer] = useState("");
//   const [items, setItems] = useState([]);
//   const [particulars, setParticulars] = useState("");
//   const [quantity, setQuantity] = useState("");
//   const [rate, setRate] = useState("");
//   const [totalAmount, setTotalAmount] = useState(0);
//   const [vat, setVat] = useState(0);
//   const [finalTotalAmount, setFinalTotalAmount] = useState(0);
//   const [amountInWords, setAmountInWords] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [isFetching, setIsFetching] = useState(true); // New state for fetching
//   const [errorMessage, setErrorMessage] = useState("");

//   const { user } = useAuth();
//   const createdBy = user?.name || "";

//   const parsePositiveNumber = (value) => {
//     const number = parseFloat(value);
//     return isNaN(number) || number < 0 ? 0 : number;
//   };

//   // useEffect(() => {
//   //   const fetchInvoice = async () => {
//   //     try {
//   //       const response = await API.get(`/invoices/${id}`);
//   //       const invoice = response.data;

//   //       console.log(invoice);

//   //       setInvoiceData(invoice);
//   //       setCustomer(invoice.invoiceDetails.client || "");
//   //       setItems(invoice.invoiceDetails.items || []);
//   //       setAmountInWords(invoice.invoiceDetails.amountInWords || "");
//   //     } catch (error) {
//   //       console.error("Error fetching invoice:", error);
//   //       alert("Failed to load invoice data.");
//   //     }
//   //   };

//   //   fetchInvoice();
//   // }, [id]);

//   // Recalculate sub total, VAT, and grand total whenever items change

//   useEffect(() => {
//     const fetchInvoice = async () => {
//       if (!id) {
//         setErrorMessage("Invalid invoice ID");
//         setIsFetching(false);
//         return;
//       }

//       try {
//         console.log("Fetching invoice with ID:", id); // Debug log
//         const response = await API.get(`/invoices/${id}`);
//         const invoice = response.data;
//         console.log("Fetched invoice:", invoice); // Debug log

//         setInvoiceData(invoice);
//         setCustomer(invoice.invoiceDetails.client || "");
//         setItems(invoice.invoiceDetails.items || []);
//         setAmountInWords(invoice.invoiceDetails.amountInWords || "");
//       } catch (error) {
//         console.error("Error fetching invoice:", error);
//         setErrorMessage(
//           error.response?.data?.message || "Failed to load invoice data"
//         );
//       } finally {
//         setIsFetching(false);
//       }
//     };

//     fetchInvoice();
//   }, [id]);

//   useEffect(() => {
//     const subTotal = items.reduce((acc, item) => acc + (item.total || 0), 0);
//     const vatAmount = Math.round(subTotal * 0.18);
//     const finalTotal = subTotal + vatAmount;

//     setTotalAmount(subTotal);
//     setVat(vatAmount);
//     setFinalTotalAmount(finalTotal);
//   }, [items]);

//   const addItem = () => {
//     const qty = parsePositiveNumber(quantity);
//     const price = parsePositiveNumber(rate);

//     if (particulars.trim() && qty > 0 && price > 0) {
//       const total = qty * price;
//       setItems([...items, { particulars, quantity: qty, rate: price, total }]);
//       setParticulars("");
//       setQuantity("");
//       setRate("");
//     }
//   };

//   const deleteItem = (index) => {
//     const confirmDelete = window.confirm(
//       "Are you sure you want to delete this item?"
//     );
//     if (confirmDelete) {
//       setItems(items.filter((_, i) => i !== index));
//     }
//   };

//   const updateInvoice = async () => {
//     if (!isFormValid) {
//       return alert("Please add a customer name and at least one item.");
//     }

//     setIsLoading(true);

//     const payload = {
//       customer: { client: customer },
//       items,
//       invoiceHeader: {
//         companyName: invoiceData?.invoiceDetails.companyName || "",
//         companyTIN: invoiceData?.invoiceDetails.companyTIN || "",
//         address: invoiceData?.invoiceDetails.address || "",
//         phone: invoiceData?.invoiceDetails.phone || "",
//         email: invoiceData?.invoiceDetails.email || [],
//         description: invoiceData?.invoiceDetails.description || "",
//       },
//       invoiceDetails: {
//         date:
//           invoiceData?.invoiceDetails.date ||
//           new Date().toISOString().slice(0, 10),
//         amountInWords,
//         totalAmount: finalTotalAmount, // Use the updated grand total
//         vat, // Use the calculated VAT
//       },
//       createdBy: createdBy || invoiceData?.invoiceDetails.createdBy || "",
//     };

//     try {
//       await API.put(`/invoices/${id}`, payload);
//       onInvoiceUpdated();
//       setIsModalOpen(false);
//     } catch (error) {
//       console.error("Update error:", error);
//       alert(
//         `Failed to update invoice: ${
//           error.response?.data?.message || error.message || "Unknown error"
//         }`
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const isFormValid = customer.trim() && items.length > 0 && !isLoading;

//   if (!invoiceData)
//     return (
//       <div className="text-center mt-10 text-gray-600">Loading invoice...</div>
//     );

//   return (
//     // <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 sm:p-4 z-50">
//     //   <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100">
//     //     <div className="p-4 sm:p-6 max-h-[85vh] overflow-y-auto">
//     //       <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">
//     //         Edit Invoice{" "}
//     //       </h2>

//     //       <input
//     //         type="text"
//     //         className="border border-gray-300 p-2 rounded w-full mb-4"
//     //         placeholder="Customer Name"
//     //         value={customer}
//     //         onChange={(e) => setCustomer(e.target.value)}
//     //       />

//     //       <div className="mb-4 grid grid-cols-1 md:grid-cols-4 gap-2">
//     //         <input
//     //           type="text"
//     //           className="border border-gray-300 p-2 rounded"
//     //           placeholder="Particulars"
//     //           value={particulars}
//     //           onChange={(e) => setParticulars(e.target.value)}
//     //         />
//     //         <input
//     //           type="number"
//     //           className="border border-gray-300 p-2 rounded"
//     //           placeholder="Qty"
//     //           value={quantity}
//     //           onChange={(e) => setQuantity(e.target.value)}
//     //         />
//     //         <input
//     //           type="number"
//     //           className="border border-gray-300 p-2 rounded"
//     //           placeholder="Rate (UGX)"
//     //           value={rate}
//     //           onChange={(e) => setRate(e.target.value)}
//     //         />
//     //         <button
//     //           onClick={addItem}
//     //           className="bg-blue-600 text-white rounded px-4 py-2 hover:bg-blue-700"
//     //         >
//     //           Add Item
//     //         </button>
//     //       </div>

//     //       <div className="overflow-y-auto max-h-64 border rounded">
//     //         <table className="w-full text-sm">
//     //           <thead className="bg-gray-100">
//     //             <tr>
//     //               <th className="border px-2 py-1">Particulars</th>
//     //               <th className="border px-2 py-1">Qty</th>
//     //               <th className="border px-2 py-1">Rate</th>
//     //               <th className="border px-2 py-1">Total</th>
//     //               <th className="border px-2 py-1">Actions</th>
//     //             </tr>
//     //           </thead>
//     //           <tbody>
//     //             {items.map((item, idx) => (
//     //               <tr key={idx} className="text-center">
//     //                 <td className="border px-2 py-1">{item.particulars}</td>
//     //                 <td className="border px-2 py-1">{item.quantity}</td>
//     //                 <td className="border px-2 py-1">{item.rate}</td>
//     //                 <td className="border px-2 py-1">{item.total}</td>
//     //                 <td className="border px-2 py-1">
//     //                   <button
//     //                     onClick={() => deleteItem(idx)}
//     //                     className="bg-red-500 text-white rounded px-2 py-1 hover:bg-red-600"
//     //                   >
//     //                     Delete
//     //                   </button>
//     //                 </td>
//     //               </tr>
//     //             ))}
//     //           </tbody>
//     //         </table>
//     //       </div>

//     //       <div className="text-right text-lg font-semibold text-gray-700 m-4">
//     //         <p>Sub Total: UGX {totalAmount.toLocaleString()}</p>
//     //         <p>VAT (18%): UGX {vat.toLocaleString()}</p>
//     //         <p>Grand Total: UGX {finalTotalAmount.toLocaleString()}</p>
//     //       </div>

//     //       <input
//     //         type="text"
//     //         className="border border-gray-300 p-2 rounded w-full"
//     //         placeholder="Amount in words"
//     //         value={amountInWords}
//     //         onChange={(e) => setAmountInWords(e.target.value)}
//     //       />

//     //       <div className="flex justify-end space-x-3 mt-4">
//     //         <button
//     //           onClick={updateInvoice}
//     //           disabled={!isFormValid}
//     //           className={`px-4 py-2 rounded text-white ${
//     //             isFormValid
//     //               ? "bg-green-600 hover:bg-green-700"
//     //               : "bg-gray-400 cursor-not-allowed"
//     //           }`}
//     //         >
//     //           {isLoading ? "Updating..." : "Update Invoice"}
//     //         </button>
//     //         <button
//     //           onClick={() => setIsModalOpen(false)}
//     //           className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
//     //         >
//     //           Cancel
//     //         </button>
//     //       </div>
//     //     </div>
//     //   </div>
//     // </div>
//     // <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 sm:p-4 z-50">
//     //   <div className="w-full h-[450px] p-4 max-h-[80vh] max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100 flex flex-col">
//     //     {/* Header (Static) */}
//     //     <div className="">
//     //       {/* Static Header */}
//     //       <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4">
//     //         Edit Invoice
//     //       </h2>
//     //       <ErrorMessage message={errorMessage} />
//     //     </div>
//     //     <div className="">
//     //       <input
//     //         type="text"
//     //         className="border border-gray-300 p-2 rounded w-full mb-2"
//     //         placeholder="Customer Name"
//     //         value={customer}
//     //         onChange={(e) => setCustomer(e.target.value)}
//     //       />
//     //     </div>

//     //     {/* Item Input Section */}
//     //     <div className="grid grid-cols-1 md:grid-cols-4 gap-2 mb-4">
//     //       <input
//     //         type="text"
//     //         className="border border-gray-300 p-2 rounded"
//     //         placeholder="Particulars"
//     //         value={particulars}
//     //         onChange={(e) => setParticulars(e.target.value)}
//     //       />
//     //       <input
//     //         type="number"
//     //         className="border border-gray-300 p-2 rounded"
//     //         placeholder="Qty"
//     //         value={quantity}
//     //         // onChange={(e) => setQuantity(parseInt(e.target.value) || 0)} // Ensure it's a number
//     //         onChange={(e) => setQuantity(e.target.value)}
//     //       />
//     //       <input
//     //         type="number"
//     //         className="border border-gray-300 p-2 rounded"
//     //         placeholder="Rate (UGX)"
//     //         value={rate}
//     //         onChange={(e) => setRate(e.target.value)}
//     //       />
//     //       <button
//     //         onClick={addItem}
//     //         className="bg-blue-500 text-white px-4 py-2 rounded"
//     //       >
//     //         Add Item
//     //       </button>
//     //     </div>

//     //     {/* Scrollable Content */}
//     //     <div className="flex-1 overflow-y-auto space-y-3">
//     //       <table className="w-full border-collapse border border-gray-300">
//     //         <thead>
//     //           <tr className="bg-gray-200">
//     //             <th className="border p-2">Particulars</th>
//     //             <th className="border p-2">Qty</th>
//     //             <th className="border p-2">Rate (UGX)</th>
//     //             <th className="border p-2">Total (UGX)</th>
//     //             <th className="border p-2">Actions</th>
//     //           </tr>
//     //         </thead>
//     //         <tbody>
//     //           {items.map((item, index) => (
//     //             <tr key={index} className="text-center">
//     //               <td className="border p-2">{item.particulars}</td>
//     //               <td className="border p-2">{item.quantity}</td>
//     //               <td className="border p-2">{item.rate}</td>
//     //               <td className="border p-2">{item.total}</td>
//     //               <td className="border p-2">
//     //                 <button
//     //                   onClick={() => deleteItem(index)}
//     //                   className="bg-red-500 text-white px-2 py-1 rounded"
//     //                 >
//     //                   Delete
//     //                 </button>
//     //               </td>
//     //             </tr>
//     //           ))}
//     //         </tbody>
//     //       </table>
//     //       {/* Invoice Totals */}
//     //       <div className="mt-4 text-right text-lg font-semibold text-gray-800">
//     //         <p>Sub Total: UGX {totalAmount.toLocaleString()}</p>
//     //         <p>VAT 18%: UGX {vat.toLocaleString()}</p>
//     //         <p>Grand Total: UGX {finalTotalAmount.toLocaleString()}</p>
//     //       </div>
//     //     </div>

//     //     <div className="mt-2 p-2">
//     //       {/* Amount in Words */}
//     //       <div>
//     //         <input
//     //           type="text"
//     //           className="border border-gray-300 p-2 rounded w-full my-2"
//     //           placeholder="Amount in words"
//     //           value={amountInWords}
//     //           onChange={(e) => setAmountInWords(e.target.value)}
//     //         />
//     //       </div>

//     //       {/* Action buttons */}
//     //       <div className="flex justify-end gap-3 ">
//     //         <button
//     //           type="button"
//     //           onClick={() => setIsModalOpen(false)}
//     //           className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto"
//     //         >
//     //           Cancel
//     //         </button>
//     //         <button
//     //           type="button"
//     //           onClick={updateInvoice}
//     //           disabled={!isFormValid || isLoading}
//     //           className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto ${
//     //             !isFormValid || isLoading
//     //               ? "bg-gray-300 text-gray-600 cursor-not-allowed"
//     //               : "bg-blue-500 text-white hover:bg-blue-600"
//     //           }`}
//     //         >
//     //           {isLoading ? "Submitting..." : "Submit"}
//     //         </button>
//     //       </div>
//     //     </div>
//     //   </div>
//     // </div>

//     <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 z-50">
//       <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100 flex flex-col h-[90vh] sm:h-[80vh]">
//         {/* Header */}
//         <div className="p-4 border-b">
//           <h2 className="text-xl sm:text-2xl font-semibold text-gray-800">
//             Edit Invoice
//           </h2>
//           <ErrorMessage message={errorMessage} />
//         </div>

//         {/* Scrollable Content */}
//         <div className="flex-1 overflow-y-auto px-4 py-2 space-y-4">
//           {/* Customer */}
//           <input
//             type="text"
//             className="border border-gray-300 p-2 rounded w-full"
//             placeholder="Customer Name"
//             value={customer}
//             onChange={(e) => setCustomer(e.target.value)}
//           />

//           {/* Item Inputs (stacked on mobile) */}
//           <div className="space-y-2 sm:space-y-0 sm:grid sm:grid-cols-4 sm:gap-2">
//             <input
//               type="text"
//               className="border border-gray-300 p-2 rounded w-full"
//               placeholder="Particulars"
//               value={particulars}
//               onChange={(e) => setParticulars(e.target.value)}
//             />
//             <input
//               type="number"
//               className="border border-gray-300 p-2 rounded w-full"
//               placeholder="Qty"
//               value={quantity}
//               onChange={(e) => setQuantity(e.target.value)}
//             />
//             <input
//               type="number"
//               className="border border-gray-300 p-2 rounded w-full"
//               placeholder="Rate (UGX)"
//               value={rate}
//               onChange={(e) => setRate(e.target.value)}
//             />
//             <button
//               onClick={addItem}
//               className="bg-blue-500 text-white px-4 py-2 rounded w-full"
//               disabled={
//                 particulars.trim() === "" ||
//                 parseFloat(quantity) <= 0 ||
//                 parseFloat(rate) <= 0
//               }
//             >
//               Add Item
//             </button>
//           </div>

//           {/* Items Table */}
//           <div className="overflow-x-auto">
//             <table className="w-full border-collapse border border-gray-300 text-sm">
//               <thead>
//                 <tr className="bg-gray-200">
//                   <th className="border p-1">Particulars</th>
//                   <th className="border p-1">Qty</th>
//                   <th className="border p-1">Rate</th>
//                   <th className="border p-1">Total</th>
//                   <th className="border p-1">Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {items.map((item, index) => (
//                   <tr key={index} className="text-center">
//                     <td className="border p-1">{item.particulars}</td>
//                     <td className="border p-1">{item.quantity}</td>
//                     <td className="border p-1">{item.rate}</td>
//                     <td className="border p-1">{item.total}</td>
//                     <td className="border p-1">
//                       <button
//                         onClick={() => deleteItem(index)}
//                         className="bg-red-500 text-white px-2 py-1 rounded text-xs"
//                       >
//                         Delete
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* Totals */}
//           <div className="text-right text-base font-semibold text-gray-800">
//             <p>Sub Total: UGX {totalAmount.toLocaleString()}</p>
//             <p>VAT (18%): UGX {vat.toLocaleString()}</p>
//             <p>Grand Total: UGX {finalTotalAmount.toLocaleString()}</p>
//           </div>

//           {/* Amount in Words */}
//           <input
//             type="text"
//             className="border border-gray-300 p-2 rounded w-full"
//             placeholder="Amount in words"
//             value={amountInWords}
//             onChange={(e) => setAmountInWords(e.target.value)}
//           />
//         </div>

//         {/* Footer Buttons */}
//         <div className="p-4 border-t flex flex-col sm:flex-row justify-end gap-2">
//           <button
//             type="button"
//             onClick={() => setIsModalOpen(false)}
//             className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 text-sm font-medium w-full sm:w-auto"
//           >
//             Cancel
//           </button>
//           <button
//             type="button"
//             onClick={updateInvoice}
//             disabled={!isFormValid || isLoading}
//             className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto ${
//               !isFormValid || isLoading
//                 ? "bg-gray-300 text-gray-600 cursor-not-allowed"
//                 : "bg-blue-500 text-white hover:bg-blue-600"
//             }`}
//           >
//             {isLoading ? "Submitting..." : "Submit"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default EditInvoiceForm;

import { useState, useEffect } from "react";
import { useAuth } from "../Context/AuthContext";
import API from "../Context/api";
import ErrorMessage from "../Helpers/ErrorMessage";
import Spinner from "../Helpers/Spinner";

function EditInvoiceForm({ id, setIsModalOpen, onInvoiceUpdated }) {
  const [invoiceData, setInvoiceData] = useState(null);
  const [customer, setCustomer] = useState("");
  const [items, setItems] = useState([]);
  const [particulars, setParticulars] = useState("");
  const [quantity, setQuantity] = useState("");
  const [rate, setRate] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [vat, setVat] = useState(0);
  const [finalTotalAmount, setFinalTotalAmount] = useState(0);
  const [amountInWords, setAmountInWords] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(true); // New state for fetching
  const [errorMessage, setErrorMessage] = useState("");

  const { user } = useAuth();
  const createdBy = user?.name || "";

  const parsePositiveNumber = (value) => {
    const number = parseFloat(value);
    return isNaN(number) || number < 0 ? 0 : number;
  };

  useEffect(() => {
    const fetchInvoice = async () => {
      if (!id) {
        setErrorMessage("Invalid invoice ID");
        setIsFetching(false);
        return;
      }

      try {
        console.log("Fetching invoice with ID:", id); // Debug log
        const response = await API.get(`/invoices/${id}`);
        const invoice = response.data;
        console.log("Fetched invoice:", invoice); // Debug log

        setInvoiceData(invoice);
        setCustomer(invoice.invoiceDetails.client || "");
        setItems(invoice.invoiceDetails.items || []);
        setAmountInWords(invoice.invoiceDetails.amountInWords || "");
      } catch (error) {
        console.error("Error fetching invoice:", error);
        setErrorMessage(
          error.response?.data?.message || "Failed to load invoice data"
        );
      } finally {
        setIsFetching(false);
      }
    };

    fetchInvoice();
  }, [id]);

  useEffect(() => {
    const subTotal = items.reduce((acc, item) => acc + (item.total || 0), 0);
    const vatAmount = Math.round(subTotal * 0.18);
    const finalTotal = subTotal + vatAmount;

    setTotalAmount(subTotal);
    setVat(vatAmount);
    setFinalTotalAmount(finalTotal);
  }, [items]);

  const addItem = () => {
    const qty = parsePositiveNumber(quantity);
    const price = parsePositiveNumber(rate);

    if (particulars.trim() && qty > 0 && price > 0) {
      const total = qty * price;
      setItems([...items, { particulars, quantity: qty, rate: price, total }]);
      setParticulars("");
      setQuantity("");
      setRate("");
    } else {
      setErrorMessage("Please provide valid particulars, quantity, and rate");
    }
  };

  const deleteItem = (index) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this item?"
    );
    if (confirmDelete) {
      setItems(items.filter((_, i) => i !== index));
    }
  };

  const updateInvoice = async () => {
    if (!isFormValid) {
      setErrorMessage("Please add a customer name and at least one item");
      return;
    }

    setIsLoading(true);
    const payload = {
      customer: { client: customer },
      items,
      invoiceHeader: {
        companyName: invoiceData?.invoiceDetails.companyName || "",
        companyTIN: invoiceData?.invoiceDetails.companyTIN || "",
        address: invoiceData?.invoiceDetails.address || "",
        phone: invoiceData?.invoiceDetails.phone || "",
        email: invoiceData?.invoiceDetails.email || [],
        description: invoiceData?.invoiceDetails.description || "",
      },
      invoiceDetails: {
        date:
          invoiceData?.invoiceDetails.date ||
          new Date().toISOString().slice(0, 10),
        amountInWords,
        totalAmount: finalTotalAmount,
        vat,
      },
      createdBy: createdBy || invoiceData?.invoiceDetails.createdBy || "",
    };

    try {
      await API.put(`/invoices/${id}`, payload);
      onInvoiceUpdated();
      setIsModalOpen(false);
    } catch (error) {
      console.error("Update error:", error);
      setErrorMessage(
        error.response?.data?.message || "Failed to update invoice"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const isFormValid = customer.trim() && items.length > 0 && !isLoading;

  // if (isFetching) {
  //   return (
  //     <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 z-50">
  //       <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg p-4 text-center">
  //         <p className="text-gray-600">Loading invoice...</p>
  //       </div>
  //     </div>
  //   );
  // }

  if (errorMessage) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 z-50">
        <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg p-4">
          <ErrorMessage message={errorMessage} />
          <div className="flex justify-end mt-4">
            <button
              onClick={() => setIsModalOpen(false)}
              className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 p-3 z-50">
      <div className="w-full max-w-md sm:max-w-lg lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 scale-100 flex flex-col h-[90vh] sm:h-[80vh]">
        {isFetching && (
          <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-opacity-50 bg-gray-100 z-10">
            <Spinner />
          </div>
        )}

        {/* Header */}
        <div className="p-4 border-b">
          <h2 className="text-xl sm:text-2xl font-semibold text-gray-800">
            Edit Invoice
          </h2>
          <ErrorMessage message={errorMessage} />
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 overflow-y-auto px-4 py-2 space-y-4">
          {/* Customer */}
          <input
            type="text"
            className="border border-gray-300 p-2 rounded w-full"
            placeholder="Customer Name"
            value={customer}
            onChange={(e) => setCustomer(e.target.value)}
          />

          {/* Item Inputs (stacked on mobile) */}
          <div className="space-y-2 sm:space-y-0 sm:grid sm:grid-cols-4 sm:gap-2">
            <input
              type="text"
              className="border border-gray-300 p-2 rounded w-full"
              placeholder="Particulars"
              value={particulars}
              onChange={(e) => setParticulars(e.target.value)}
            />
            <input
              type="number"
              className="border border-gray-300 p-2 rounded w-full"
              placeholder="Qty"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            />
            <input
              type="number"
              className="border border-gray-300 p-2 rounded w-full"
              placeholder="Rate (UGX)"
              value={rate}
              onChange={(e) => setRate(e.target.value)}
            />
            <button
              onClick={addItem}
              className="bg-blue-500 text-white px-4 py-2 rounded w-full disabled:bg-gray-300 disabled:cursor-not-allowed"
              disabled={
                particulars.trim() === "" ||
                parseFloat(quantity) <= 0 ||
                parseFloat(rate) <= 0
              }
            >
              Add Item
            </button>
          </div>

          {/* Items Table */}
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-300 text-sm">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border p-1">Particulars</th>
                  <th className="border p-1">Qty</th>
                  <th className="border p-1">Rate</th>
                  <th className="border p-1">Total</th>
                  <th className="border p-1">Action</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr key={index} className="text-center">
                    <td className="border p-1">{item.particulars}</td>
                    <td className="border p-1">{item.quantity}</td>
                    <td className="border p-1">{item.rate}</td>
                    <td className="border p-1">{item.total}</td>
                    <td className="border p-1">
                      <button
                        onClick={() => deleteItem(index)}
                        className="bg-red-500 text-white px-2 py-1 rounded text-xs"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Totals */}
          <div className="text-right text-base font-semibold text-gray-800">
            <p>Sub Total: UGX {totalAmount.toLocaleString()}</p>
            <p>VAT (18%): UGX {vat.toLocaleString()}</p>
            <p>Grand Total: UGX {finalTotalAmount.toLocaleString()}</p>
          </div>

          {/* Amount in Words */}
          <input
            type="text"
            className="border border-gray-300 p-2 rounded w-full"
            placeholder="Amount in words"
            value={amountInWords}
            onChange={(e) => setAmountInWords(e.target.value)}
          />
        </div>

        {/* Footer Buttons */}
        <div className="p-4 border-t flex flex-col sm:flex-row justify-end gap-2">
          <button
            type="button"
            onClick={() => setIsModalOpen(false)}
            className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 text-sm font-medium w-full sm:w-auto"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={updateInvoice}
            disabled={!isFormValid || isLoading}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto ${
              !isFormValid || isLoading
                ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                : "bg-blue-500 text-white hover:bg-blue-600"
            }`}
          >
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditInvoiceForm;
